import { useState, ChangeEvent } from 'react';
import { Input } from 'antd';
import Icon from '@ant-design/icons';
import IconSearch from 'assets/icons/ic_search_gray.svg';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import { useTranslation } from 'react-i18next';

const { Search } = Input;

export const CustomIcon = styled(Icon)`
  img {
    height: 15px;
    width: 15px;
  }
`;

const IconSearchPrefix = <CustomIcon component={() => <img src={IconSearch} alt="" />} />;

interface ITVSearchProps {
  handleSearch?: any;
  search?: string;
  setLoading?(isLoading: boolean): void;
  debounceWait?: number;
}

const ITVSearch = (props: any) => {
  const { handleSearch, search, setLoading, debounceWait = 500, ...rest }: ITVSearchProps = props;

  const { t } = useTranslation(['action', 'onboard']);
  const [value, setValue] = useState('');

  const executeSearch = async (nextValue: string) => {
    try {
      await handleSearch?.(nextValue);
    } finally {
      setLoading?.(false);
    }
  };

  const debounced = useDebouncedCallback(executeSearch, debounceWait);

  const handleOnChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value;
    setValue(nextValue);
    setLoading?.(true);
    debounced(nextValue);
  };

  const handleSubmitSearch = (nextValue: string) => {
    debounced.cancel();
    setValue(nextValue);
    setLoading?.(true);
    void executeSearch(nextValue);
  };

  return (
    <CustomSearch
      placeholder={search === 'mail' ? t('onboard:LabelFormEmail.search') : t('action:search')}
      size="large"
      prefix={IconSearchPrefix}
      value={value}
      onSearch={handleSubmitSearch}
      onChange={handleOnChangeSearch}
      {...rest}
    />
  );
};

export default ITVSearch;

export const CustomSearch = styled(Search)`
  width: 300px;
  .ant-input-group-addon {
    display: none;
  }
  .ant-input-affix-wrapper {
    height: 32px;
    input {
      font-size: 14px;
    }
  }
`;
